module.exports = __webpack_public_path__ + "static/media/LK__EV charger_blue.a86aa74b.svg";